@if (peutModifier()) {
  <a [class]="_computedClass()" [hlmDropdownMenuTrigger]="menu" href="#">
    <span>{{ label() }}</span>
    <ng-icon name="lucideChevronDown" hlm size="sm" />
  </a>
} @else {
  <div [class]="_computedClass()">
    <span>{{ label() }}</span>
  </div>
}

<ng-template #menu>
  <hlm-dropdown-menu class="w-max">
    @for (item of etatReferentielLivrable | keyvalue: null; track item.key) {
      <button (triggered)="changeEtat(item.key)" hlmDropdownMenuItem>{{ item.value }}</button>
    }
  </hlm-dropdown-menu>
</ng-template>
